/**
 * A labelled on/off switch. Built on a real checkbox so it stays keyboard
 * reachable and reports its state to screen readers.
 */
export default function Toggle({ id, checked, onChange, label, hint, error, disabled }) {
  return (
    <div>
      <label htmlFor={id} className="flex cursor-pointer items-start gap-3">
        <span className="relative mt-1 inline-flex flex-shrink-0">
          <input
            id={id}
            type="checkbox"
            className="peer sr-only"
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
          />
          <span
            className="block h-5 w-9 rounded-full bg-line-strong transition-colors duration-fast
              peer-checked:bg-accent peer-focus-visible:ring-2 peer-focus-visible:ring-accent-line
              peer-disabled:!bg-line"
          />
          <span
            className="pointer-events-none absolute start-0.5 top-0.5 h-4 w-4 rounded-full bg-surface
              shadow transition-transform peer-checked:translate-x-4 rtl:peer-checked:-translate-x-4"
          />
        </span>
        <span className="min-w-0">
          <span className="block text-sm font-semibold text-ink">{label}</span>
          {hint && <span className="block text-xs text-ink-2">{hint}</span>}
        </span>
      </label>
      {error && <p className="field-error">{error}</p>}
    </div>
  );
}
